import { RouteComponentProps } from '@reach/router';
import Page from 'components/shared/Page';
import React, { useEffect, useState } from 'react';
import { endpoints } from '../../endpoints.config';
import { InfoTable } from 'components/infoTable/infoTable';
import { ManageUsersMenuOptions } from './ManageUsersMenuOptions';
import { ManageUsersDropdownOptions } from './ManageUsersDropdownOptions';
import { selectUpdateUsersList, setUpdateUsersList } from 'reducers/misc';
import { useDispatch, useSelector } from 'react-redux';

const dropdrownMenuOptions = (
  id: number,
  name: string,
  closeMenu: () => void,
  openCloseState: { open: boolean; id: number | null }
) => (
  <ManageUsersDropdownOptions
    rowId={id}
    closeMenu={closeMenu}
    openCloseState={openCloseState}
  />
);

export const ManageUsers: React.FC<RouteComponentProps> = () => {
  const updateUsersListStatus: boolean = useSelector(selectUpdateUsersList);
  const [isPanelClosed, setIsPanelClosed] = useState<boolean>(true);

  const dispatch = useDispatch();
  const setUpdateList = (status: boolean) =>
    dispatch(setUpdateUsersList(status));

  useEffect(() => {
    return () => {
      setUpdateList(true);
    };
  }, []);

  useEffect(() => {
    //clear saved list params when updating table items
    localStorage.removeItem('updateItemTableParams');
  }, []);  

  return (
    <Page>
      <div className="PageContent ManageUsersPage WidthContent">
        <InfoTable
          title="Manage Users"
          listUrl={endpoints.manageUsers.list}
          firstColWidth={300}
          firstColWidthSm={80}
          buttonText={'Add new user'}
          secondButtonText={'Bulk Edit / Bulk Upload'}
          dropdrownMenuOptions={dropdrownMenuOptions}
          updateListStatus={updateUsersListStatus}
          setUpdateList={setUpdateList}
          setIsPanelClosed={setIsPanelClosed}
          isPanelClosed={isPanelClosed}
        >
          <ManageUsersMenuOptions />
        </InfoTable>
      </div>
    </Page>
  );
};
